
import { defineComponent, toRef } from '@vue/composition-api';
import ScorePlot from '@/components/vis/ScorePlot.vue';
import ScorePlotHelp from '@/components/vis/help/ScorePlotHelp.vue';
import VisTile from '@/components/vis/VisTile.vue';
import usePlotData from '../use/usePlotData';

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true,
    },
    pcX: {
      type: Number,
      required: true,
    },
    pcY: {
      type: Number,
      required: true,
    },
    showEllipses: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ScorePlot,
    ScorePlotHelp,
    VisTile,
  },
  setup(props) {
    const { plot, dataset } = usePlotData(toRef(props, 'id'), 'pca');
    return {
      plot,
      dataset,
    };
  },
});
